"use client";

import { useEffect } from "react";
import Cookies from "js-cookie";
import { parseShopifyHost } from "../utils/parseShopifyHost";

export default function StoreLimitTracker() {
  useEffect(() => {
    async function fetchStoreLimit() {
      try {
        const { shopName } = parseShopifyHost();
        const activeShopName = shopName;
        const isVerified = Cookies.get("store_verified") === "true";
        if (!activeShopName) {
          console.warn("shopName is empty, skipping storeLimit API call"); // 👈 at least log it
          return;
        }
        const apiUrl = `/api/storeLimit?storeHash=${activeShopName}&verified=${isVerified}`;

        const response = await fetch(apiUrl);

        if (!response.ok) {
          console.error(`API call failed with status: ${response.status}`);
        }

        const json = await response.json();

        if (Cookies.get("store_verified") === undefined) {
          const verifiedValue =
            json?.data?.data?.verified || json?.data?.verified;

          if (verifiedValue !== undefined) {
            Cookies.set("store_verified", String(verifiedValue), {
              expires: 7,
              sameSite: "None",
              secure: true,
            });
          }
        }
      } catch (error) {
        console.error("Failed to track store limit:", error);
      }
    }

    fetchStoreLimit();
  }, []);

  return null;
}
